import type { ReactElement } from 'react';
import { Stack, type StackProps } from './stack';

type HStackProps = Omit<StackProps, 'direction'>;

/** `Stack` fixed to `direction="horizontal"` — a row flexbox with the shared gap/align/justify scale. */
export const HStack = (props: HStackProps): ReactElement => (
  <Stack direction="horizontal" {...props} />
);
